module.exports = __webpack_public_path__ + "img/logoOpenClassRooms.5518a594.svg";